import { Link, useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

/**
 * Persistent reminder shown to logged-in users who haven't verified their
 * email yet. Deposits and betting are blocked until they do. Hidden on the
 * verification screen itself and on auth pages.
 */
export default function VerifyEmailBanner() {
  const { user } = useAuth();
  const location = useLocation();

  const hiddenOn = ['/verify-email', '/login', '/register'];
  if (!user || user.email_verified || hiddenOn.includes(location.pathname)) {
    return null;
  }

  return (
    <div className="sticky top-0 z-40 bg-warning/90 px-4 py-2 text-center text-sm font-medium text-white backdrop-blur">
      ✉️ Verify your email to deposit &amp; bet.{' '}
      <Link to="/verify-email" className="font-bold underline">
        Enter your code
      </Link>
    </div>
  );
}
